import { forwardRef, useImperativeHandle } from 'react';
import type { StudioRef } from '../../types';
import { useJournalHandle } from '../hooks/use-journal-handle';
import { useWindowedSubmitData } from '../hooks/use-windowed-submit-data';
import { useWindowedValidations } from '../hooks/use-windowed-validations';
export type WindowedHandles = Pick<StudioRef, 'drainJournal' | 'getPendingJournalCount' | 'getWindowedSubmitData' | 'getValidations'>;
export const WINDOWED_HANDLES_DEFAULTS: WindowedHandles = {
  drainJournal: () => Promise.resolve(),
  getPendingJournalCount: () => Promise.resolve(0),
  getWindowedSubmitData: () => null,
  getValidations: () => ({
    containsPendingItem: false,
    containsRejectedAnnotation: false
  })
};
export const WindowedHandlesInitializer = forwardRef<WindowedHandles>(function WindowedHandlesInitializer(_, ref) {
  const {
    drainJournal,
    getPendingJournalCount
  } = useJournalHandle();
  const {
    getWindowedSubmitData
  } = useWindowedSubmitData();
  const {
    getValidations
  } = useWindowedValidations();
  useImperativeHandle(ref, () => ({
    drainJournal,
    getPendingJournalCount,
    getWindowedSubmitData,
    getValidations
  }), [drainJournal, getPendingJournalCount, getWindowedSubmitData, getValidations]);
  return null;
});